import * as React from 'react';
import './ProtectedRoute.scss';
import { FunctionComponent, useEffect, useState } from 'react';
import { Navigate } from 'react-router';
import { HOME_ROUTE } from '../utils/consts';
import { AccessStore } from '../store/Access';
import { Spinner } from '@iba-team/portal-react-components/dist';
import { observer } from 'mobx-react';
import { AccessTypeCode } from '../types';

export interface ProtectedRouteProps {
  children: any,
  itemCode: AccessTypeCode,
}

const ProtectedRoute: FunctionComponent<ProtectedRouteProps> = observer((props) => {

  const [isAllowed, setIsAllowed] = useState(false);
  const [spinner, setSpinner] = useState(true);
  const {allItems, fetchMenuItems, allAccesses, isAllAccessesFetched } = AccessStore;

  useEffect(()=> {
    if (props.itemCode.type === 'MENUITEM') {
      if (!allItems.length) {
        fetchMenuItems();
      }
    }
  },[]);

  useEffect(()=> {
    if (props.itemCode.type === 'MENUITEM') {
      if (allItems.length) {
        setSpinner(false);
        setIsAllowed(!!allItems.find(el => (el.itemCode === props.itemCode.code && el.visible)));
      }
    } else {
      if (isAllAccessesFetched && allAccesses.length) {
        setSpinner(false);
        setIsAllowed(!!allAccesses.find(el => el?.actionCodes.includes(props.itemCode.code)));
      }
    }
  },[allItems, isAllAccessesFetched, allAccesses]);

  return (
    <>
      {spinner
        ?
        <div className={'spinner_wrapper'}><Spinner/></div>
        :
        isAllowed
          ?
          props.children
          :
          <Navigate to={HOME_ROUTE} replace />
      }
    </>
  );
});

export default ProtectedRoute;